// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navigation_wrapper__210y3","nav":"Navigation_nav__2AsUs","link":"Navigation_link__2BM9A","profileIcon":"Navigation_profileIcon__2TJNF"};